import { useState } from 'react';
import { useApi } from '../lib/hooks';
import { api } from '../lib/api';
import { Button, ErrorBox, Field, Loading, Panel, useAction } from '../components/ui';

const ZONES = ['America/Chicago', 'America/New_York', 'America/Denver', 'America/Los_Angeles', 'UTC', 'Europe/London', 'Europe/Berlin', 'Australia/Sydney'];

export function SettingsPage() {
  const { data, error, loading, reload } = useApi<any>('/api/admin/settings');
  const [tz, setTz] = useState<string | null>(null);
  const { busy, run } = useAction();
  if (loading && !data) return <Loading />;
  if (error) return <ErrorBox error={error} retry={reload} />;
  if (!data) return null;
  const zone = tz ?? data.timezone;
  return (
    <div className="grid-2">
      <Panel title="Platform" icon="settings">
        <Field label="Org timezone" hint="Used for scheduled backups and date displays in tools.">
          <select value={zone} onChange={(e) => setTz(e.target.value)}>
            {[...new Set([data.timezone, ...ZONES])].map((z) => <option key={z} value={z}>{z}</option>)}
          </select>
        </Field>
        <div className="panel-foot"><Button variant="primary" disabled={!tz || tz === data.timezone} busy={busy === 's'} onClick={() => run('s', async () => { await api.put('/api/admin/settings', { timezone: zone }); setTz(null); await reload(); }, 'Settings saved')}>Save</Button></div>
      </Panel>
      <Panel title="Deployment" icon="info">
        <dl className="facts">
          <div><dt>Platform version</dt><dd>v{data.platformVersion}</dd></div>
          <div><dt>Public URL</dt><dd className="mono">{data.publicUrl}</dd></div>
          <div><dt>Database</dt><dd>{data.dataBackend === 'firestore' ? 'Firestore' : 'In-memory (development)'}</dd></div>
          <div><dt>Backup storage</dt><dd>{data.storage === 'gcs' ? 'Cloud Storage' : 'Local folder (development)'}</dd></div>
          <div><dt>Discord</dt><dd>{data.discordMode === 'live' ? 'Live bot' : 'Fake server (development)'}</dd></div>
        </dl>
        <p className="muted small">Secrets (bot token, OAuth secrets, setup code) are managed in Google Secret Manager, never in the app.</p>
      </Panel>
    </div>
  );
}
